import get from 'lodash.get';

import selfServiceEvents from 'events/selfService';

export default function finalizeTimeline(dispatch, getState) {
  const { searchTerm, timeline } = getState().selfService;
  const lastTimelineItem = timeline[timeline.length - 1];
  const lastSearchTerm = get(lastTimelineItem, 'searchTerm');

  searchTerm && searchTerm !== lastSearchTerm
    ? dispatch(selfServiceEvents.finalizeTimeline([...timeline, { searchTerm }]))
    : dispatch(selfServiceEvents.finalizeTimeline([...timeline]));
}
